import {
  SESSION_ID_CHANGE_SERVICE_KEYS,
  SESSION_ID_RESET_ALL,
  SESSION_ID_SINGLE_ID_CHANGE,
  SESSION_ID_SINGLE_PRODUCT_RESET,
} from "../actions/search/types";
import update from "immutability-helper";

const sessionIdsInitial = {
  ACC: {
    page_session_id: "",
    search_session_id: "",
  },
  FL: {
    page_session_id: "",
    search_session_id: "",
  },
  TRF: {
    page_session_id: "",
    search_session_id: "",
  },
  ACT: {
    page_session_id: "",
    search_session_id: "",
  },
  FER: {
    page_session_id: "",
    search_session_id: "",
  },
  TRA: {
    page_session_id: "",
    search_session_id: "",
  },
  CAR: {
    page_session_id: "",
    search_session_id: "",
  },
};
export const SessionIds = (state = sessionIdsInitial, action) => {
  switch (action.type) {
    case SESSION_ID_CHANGE_SERVICE_KEYS: {
      const { srvType, value } = action;
      return update(state, { [srvType]: { $set: value } });
    }
    case SESSION_ID_SINGLE_ID_CHANGE: {
      const { srvType, id_type, value } = action;
      return update(state, { [srvType]: { [id_type]: { $set: value } } });
    }
    case SESSION_ID_SINGLE_PRODUCT_RESET: {
      const { srvType } = action;
      return update(state, { [srvType]: { $set: sessionIdsInitial[srvType] } });
    }
    case SESSION_ID_RESET_ALL: {
      return sessionIdsInitial;
    }
    default:
      return state;
  }
};
